/*
 * @Author: zhengxiaowen
 * @Date: 2018-09-21 09:22:02
 * @Last Modified by: zhengxiaowen
 * @Last Modified time: 2019-04-24 17:35:30
 */
import Vue from 'vue'
import Vuex from 'vuex'
import vuexI18n from 'vuex-i18n'
import VuxStore from './VuxStore'
import UserStore from './UserStore'
import SystemStore from './SystemStore'
import CustomModules from '@/store/CustomModules'

Vue.use(Vuex)

let store = new Vuex.Store({
  modules: {
    
    // 框架的store模块
    i18n: vuexI18n.store,
    vux: VuxStore,
    user: UserStore,
    system: SystemStore,

    // 私有store模块引入
    ...CustomModules
    
  }
})

export default store



// WEBPACK FOOTER //
// ./src/common/store/StoreCommon.js